// Generated from packages/shared/design-tokens/foundations.json. Run pnpm tokens:build; do not edit.
export const FOUNDATIONS = {
    "fontFamily": {
        "system": "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        "display": "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
        "plugin": "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        "mono": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace"
    },
    "fontSize": {
        "8": "8px",
        "9": "9px",
        "10": "10px",
        "11": "11px",
        "12": "12px",
        "13": "13px",
        "14": "14px",
        "16": "16px",
        "18": "18px",
        "20": "20px",
        "24": "24px",
        "28": "28px",
        "32": "32px",
        "36": "36px",
        "40": "40px",
        "42": "42px",
        "micro": "8px",
        "tiny": "9px",
        "badge": "10px",
        "caption": "11px",
        "compact": "12px",
        "small": "13px",
        "body": "14px",
        "heading": "16px",
        "title": "18px",
        "large": "20px",
        "display": "24px",
        "hero": "28px",
        "heroLarge": "28px",
        "subheadline": "32px",
        "jumbo": "36px",
        "headline": "40px",
        "headlineLarge": "42px"
    },
    "fontWeight": {
        "regular": 400,
        "medium": 500,
        "semibold": 600,
        "bold": 700
    },
    "lineHeight": {
        "solid": 1,
        "heading": 1.2,
        "tight": 1.25,
        "compact": 1.3,
        "label": 1.4,
        "body": 1.5,
        "prose": 1.6
    },
    "radius": {
        "micro": "2px",
        "badge": "4px",
        "sm": "4px",
        "issueBadge": "4px",
        "control": "6px",
        "panel": "8px",
        "dialog": "12px",
        "full": "9999px"
    },
    "space": {
        "1": "4px",
        "2": "8px",
        "3": "12px",
        "4": "16px",
        "5": "20px",
        "6": "24px",
        "8": "32px",
        "10": "40px",
        "12": "48px",
        "half": "2px",
        "1h": "6px",
        "2h": "10px",
        "3h": "14px"
    },
    "letterSpacing": {
        "tight": "-0.02em",
        "normal": "0",
        "wide": "0.05em"
    },
    "shadow": {
        "sm": "0 1px 3px rgba(16, 24, 40, 0.06)",
        "hover": "0 4px 12px rgba(16, 24, 40, 0.08), 0 1px 3px rgba(16, 24, 40, 0.05)",
        "popover": "0 4px 12px rgba(0, 0, 0, 0.1)",
        "dialog": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
        "focus": "0 0 2px rgba(52, 104, 248, 1)",
        "focusDanger": "0 0 2px rgba(239, 68, 68, 1)"
    },
    "lineBox": {
        "12": "12px",
        "16": "16px",
        "20": "20px",
        "24": "24px",
        "28": "28px",
        "32": "32px",
        "36": "36px",
        "40": "40px",
        "compact": "16px",
        "body": "20px",
        "relaxed": "24px",
        "heading": "28px",
        "title": "32px",
        "display": "36px",
        "hero": "40px"
    }
};
//# sourceMappingURL=designFoundations.js.map